{
  "version": 1,
  "asset_id": "e19b8854-3b0e-4637-9152-2daea74292f6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e19b8854-3b0e-4637-9152-2daea74292f6/lynx-gsc-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e19b8854-3b0e-4637-9152-2daea74292f6/lynx-gsc-640.webp",
  "original_filename": "lynx-gsc-640.webp",
  "size": 19764,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:39Z"
}
